import FundOpportunity from '../../models/FundOpportunity';
import { OpportunityStatus } from '../BaseBackendService';

export async function fetchFundOpportunitiesByStatuses(
  statuses: OpportunityStatus[],
  fetchByStatus: (status: OpportunityStatus) => Promise<FundOpportunity[]>,
): Promise<FundOpportunity[]> {
  const fundOpportunityResult: FundOpportunity[] = [];
  for (const status of statuses) {
    const opportunities = await fetchByStatus(status);
    opportunities.forEach((opportunity) => fundOpportunityResult.push(opportunity));
  }
  return fundOpportunityResult;
}
